import { createFileRoute } from '@tanstack/react-router';
import { PersonalSettingsRoute } from './-route-wrappers';

// Index route only. The `/settings/personal/security` screens have their own
// route files, gated on the same `personal_settings_in_hydra` flag as this one.
export const Route = createFileRoute('/_authenticated/settings/personal/')({
  component: PersonalSettingsRoute,
});
